import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useDispatch, useSelector } from 'react-redux';
import { deepCopy, getMarketSegment, getSeriesById, in_array } from '../../app/util';
import dataService from '../../services/data.service';
import { getRoomClassCategory } from './tilesData/otb_multisegment_report_functions';
import { Button, Divider } from '@mui/material';
import { Box } from '@mui/system';
import { updateAppState } from '../../actions/appstate';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function SearchFilter(props) {
    const dispatch = useDispatch();
    const state = useSelector(appState => appState);
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );


    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [options, setOptions] = React.useState([]);

    React.useEffect(() => {
        let cols = [];
        let activeTile = ui_state.active_tiles[0];
        if (props.details.type === "segment") {
            let segmentArr = [];
            switch (activeTile) {
                case "market":
                    segmentArr = getMarketSegment(ui_state.active_tiles);
                    if (ui_state.table_filters.table_reports.segments !== "all") {
                        setSelectedOptions(ui_state.table_filters.table_common.marketSegments);
                    }
                    break;
                case "otb_v2_multi_segment":
                case "bi_sensitivity_analysis":
                    let segmentType = app_state.workspace_controls.segmentType;
                    if (segmentType === "top_market_segment") {
                        segmentArr = getTopSegments();
                        if (ui_state.table_filters.table_reports[segmentType] !== "all") {
                            setSelectedOptions(ui_state.table_filters.table_reports[segmentType]);
                        }
                    } else if (segmentType === "room_class") {
                        segmentArr = getRoomClass();
                        if (ui_state.table_filters.table_reports[segmentType] !== "all") {
                            setSelectedOptions(ui_state.table_filters.table_reports[segmentType]);
                        }
                    } else if (segmentType === "rate_plan") {
                        segmentArr = getRatePlan();
                        if (ui_state.table_filters.table_reports[segmentType] !== "all") {
                            setSelectedOptions(ui_state.table_filters.table_reports[segmentType]);
                        }
                    } else if (segmentType === "room_type") {
                        segmentArr = getRoomType();
                        if (ui_state.table_filters.table_reports[segmentType] !== "all") {
                            setSelectedOptions(ui_state.table_filters.table_reports[segmentType]);
                        }
                    } else {
                        segmentArr = props.details.segments.list
                        segmentArr = segmentArr.map(v => ({ ...v, hidden: false, title: v.name, type: "reports_segments" }))
                        if (ui_state.table_filters.table_reports[segmentType] !== "all") {
                            setSelectedOptions(ui_state.table_filters.table_reports[segmentType]);
                        }
                        // debugger;
                    }

                    break;
                default:
                    segmentArr = props.details.segments.list
                    // segmentArr = segmentArr.map(v => ({ ...v, hidden: false, title: v.name, type: "property_segments" }))
                    segmentArr = segmentArr.map(v =>
                        v.name === 'Other'
                            ? { ...v, code: 'Other', hidden: false, title: v.name, type: "property_segments" }
                            : { ...v, hidden: false, title: v.name, type: "property_segments" }
                    );
                    if (ui_state.table_filters.table_common.dow[0].segments !== "all") {
                        setSelectedOptions(ui_state.table_filters.table_common.segments);
                    }

                    break;
            }
            if (ui_state.active_tiles.length > 1 && ui_state.active_tiles.includes('market')) {
                const filtered_marketIntellimergeSegments = ui_state.table_filters.table_common.marketIntellimergeSegments.filter((item) => item !== "UNMAPPED");
                setSelectedOptions(filtered_marketIntellimergeSegments);
                segmentArr = getMarketSegment(ui_state.active_tiles);
            }

            cols = segmentArr.filter((obj, index) => {
                return index === segmentArr.findIndex(o => obj.name === o.name);
            });
        }
        else {
            let dowType = (in_array(ui_state.active_tiles, ['otb_v2_multi_segment', 'bi_pace_comparison',
                'bi_pickup_analysis', 'revpar_index', 'bi_sensitivity_analysis', 'DailyRatesendStatus', 'rm_room_type_ratesend_status'])) ?
                "report_dow" : "dow";
            cols = [
                { code: "sun", hidden: false, title: "Sun", type: dowType },
                { code: "mon", hidden: false, title: "Mon", type: dowType },
                { code: "tue", hidden: false, title: "Tue", type: dowType },
                { code: "wed", hidden: false, title: "Wed", type: dowType },
                { code: "thu", hidden: false, title: "Thu", type: dowType },
                { code: "fri", hidden: false, title: "Fri", type: dowType },
                { code: "sat", hidden: false, title: "Sat", type: dowType }
            ]
            if (dowType === "dow" && ui_state.table_filters.table_common.dow[0].code !== "all") {
                setSelectedOptions(ui_state.table_filters.table_common.dow);
            } else {
                setSelectedOptions(ui_state.table_filters.table_reports.dow);
            }
        }

        setOptions(cols);

        setSelectedOptions(prev => 
            prev.length === 1 && prev[0].code === "all" ? cols : prev
        );
    }, [])

    // const handleChange = (event, value) => setSelectedOptions(value);
    const handleChange = (event, value) => {
        let eventValue = ""
        if (event.target.matches("input")) {
            eventValue = event.target.closest("li").innerText;
        }
        else if (event.target.matches("path") || event.target.matches("svg")) {
            eventValue = event.target.closest("div").innerText;
        } else {
            eventValue = event.target.innerText;
        }

        const duplicateValue = value.reduce((accumulator, currentValue) => {
            if (currentValue.title.toLowerCase() === eventValue.toLowerCase()) {
                accumulator++;
            }
            return accumulator;
        }, 0);

        setSelectedOptions(() => {
            if (duplicateValue === 1) {
                return value
            } else {
                return value.filter((item) => {
                    if (item.title.toLowerCase() !== eventValue.toLowerCase()) {
                        return item
                    }
                })
            }
        })
    };
    const handleSubmit = () => {
        let selectedVal = [];
        let segmentType = app_state.workspace_controls.segmentType;
        if (selectedOptions[0].type === "property_segments") {
            ui_state.table_filters.table_common.segments = selectedOptions;
        } else if (selectedOptions[0].type === "market_segments") {
            if (ui_state.active_tiles.length > 1 && ui_state.active_tiles.includes('market')) {
                ui_state.table_filters.table_common.marketIntellimergeSegments = selectedOptions
            } else {
                ui_state.table_filters.table_common.marketSegments = selectedOptions
            }

        } else if (selectedOptions[0].type === "reports_segments") {
            ui_state.table_filters.table_reports[segmentType] = selectedOptions
        } else if (selectedOptions[0].type === "top_segments") {
            ui_state.table_filters.table_reports[segmentType] = selectedOptions
        } else if (selectedOptions[0].type === "room_class") {
            ui_state.table_filters.table_reports[segmentType] = selectedOptions
        } else if (selectedOptions[0].type === "room_type") {
            ui_state.table_filters.table_reports[segmentType] = selectedOptions
        } else if (selectedOptions[0].type === "rate_plan") {
            if (selectedOptions.length === options.length) {
                ui_state.table_filters.table_reports.rate_plan_filter_all_selected = true
            } else {
                ui_state.table_filters.table_reports.rate_plan_filter_all_selected = false
            }
            ui_state.table_filters.table_reports[segmentType] = selectedOptions
        } else if (selectedOptions[0].type === "report_dow") {
            ui_state.table_filters.table_reports.dow = selectedOptions
        } else {
            ui_state.table_filters.table_common.dow = selectedOptions
        }
        dispatch(updateAppState("change_filter", {
            //app_state: { data_load: true },
            ui_state: {
                ...ui_state,
            }
        }, "search"));
        let selectedSegments = selectedOptions.map((item) => item.name);
        selectedSegments = [...new Set(selectedSegments)];
        props.details.applyFilterHandler(selectedSegments);
        console.log("updated global state =>> ", ui_state.table_filters);
    }

    const handleSelectAll = () => {
        setSelectedOptions(options)
    }

    const handleClearAll = () => {
        setSelectedOptions([])
        setSelectedLetter(null)
        setSearchQuery('')
    }

    const handleChangeDow = (option) => {
        const optionIndex = selectedOptions.findIndex((item) => item.title === option.title);
        if (optionIndex === -1) {
            // If the option is not in the selectedOptions array, add it.
            setSelectedOptions([...selectedOptions, option]);
        } else {
            // If the option is already in the selectedOptions array, remove it.
            setSelectedOptions(selectedOptions.filter((item) => item.title !== option.title));
        }
    };

    const getFullDay = (day) => {
        if (day === 'Sun') {
            return "Sunday";
        }
        else if (day === 'Mon') {
            return "Monday";
        }
        else if (day === 'Tue') {
            return "Tuesday";
        }
        else if (day === 'Wed') {
            return "Wednesday";
        }
        else if (day === 'Thu') {
            return "Thursday";
        }
        else if (day === 'Fri') {
            return "Friday";
        }
        else if (day === 'Sat') {
            return "Saturday";
        }
    }

    //console.log("selectedOptions", selectedOptions)

    const [isLetter, setIsLetter] = React.useState(true);

    const allLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const allNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    const letterToNumber = () => {
        if (isLetter) {
            setIsLetter(false);
            setSelectedLetter(null);
        }
        else {
            setIsLetter(true);
            setSelectedLetter(null);
        }
    };


    const [selectedLetter, setSelectedLetter] = React.useState(null);
    const handleLetterFilter = (letter) => {
        if (selectedLetter === letter) {
            setSelectedLetter(null);
        }
        else {
            setSelectedLetter(letter);
        }
    };


    const [searchQuery, setSearchQuery] = React.useState('');

    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
    };

    // let filteredOptions = options.filter((option) =>
    //     option.title.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    // let filteredOptions = options
    //     .filter((option) => {
    //         const isMatchingLetter = selectedLetter === null || option.title[0].toLowerCase() === selectedLetter.toLowerCase();
    //         return isMatchingLetter && option.title.toLowerCase().includes(searchQuery.toLowerCase());
    //     })
    //     .sort((a, b) => {
    //         const aChecked = selectedOptions.some((item) => item.title === a.title);
    //         const bChecked = selectedOptions.some((item) => item.title === b.title);

    //         if (aChecked && !bChecked) {
    //             return -1; // 'a' should come before 'b'
    //         } else if (!aChecked && bChecked) {
    //             return 1; // 'b' should come before 'a'
    //         }

    //         return 0; // Keep the same order
    //     });
    //end filteredOptions
    
    let filteredOptions = options.filter((option) => {
        const isMatchingLetter = selectedLetter === null || option.title[0].toLowerCase() === selectedLetter.toLowerCase();
        return isMatchingLetter && option.title.toLowerCase().includes(searchQuery.toLowerCase());
    });


    // if (isLetter) {
    //     const nonNumericOptions = filteredOptions.filter(option => !/\d/.test(option.title));
    //     filteredOptions = nonNumericOptions
    // }
    if (!isLetter) {
        const numericOptions = filteredOptions.filter(option => /\d/.test(option.title));
        filteredOptions = numericOptions
    }

    console.log("Selected option => ", selectedOptions);
    console.log("filteredOptions =>>", filteredOptions);

    const checkedIcon = (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="13" height="13" rx="3.5" fill="#00415F" />
            <rect x="0.5" y="0.5" width="13" height="13" rx="3.5" stroke="#00415F" />
            <path d="M3.52625 6.6413L5.53 9.4763L10.4737 4.5238" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
    const unCheckedIcon = (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="13" height="13" rx="3.5" fill="white" />
            <rect x="0.5" y="0.5" width="13" height="13" rx="3.5" stroke="#606060" />
            <path d="M3.52625 6.6413L5.53 9.4763L10.4737 4.5238" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );

    const handleLetterKeyPress = (e, letter) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (letter === '#') {
                letterToNumber();
            } else {
                handleLetterFilter(letter); 
            }
        }
    };
    const handleCheckboxKeyPress = (e, option) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            handleChangeDow(option);
        }
    };

    return (
        <>

            {props.details.type === "segment"

                ?
                // <Autocomplete
                //     multiple
                //     size="small"
                //     id="checkboxes-tags-demo"
                //     options={options}
                //     disableCloseOnSelect
                //     // disableListWrap
                //     // disablePortal={true}
                //     // defaultValue={selectedOptions}
                //     value={selectedOptions}
                //     ListboxProps={{ style: { maxHeight: 200 } }}
                //     onChange={handleChange}
                //     getOptionLabel={(option) => option.title}
                //     renderOption={(props, option, ref) => {
                //         let exists = selectedOptions.filter((item) => option.title === item.title);
                //         // let existsGlobal = seg.filter((item) => option.title === item.title);
                //         // debugger;
                //         return (
                //             <li {...props}>
                //                 <Checkbox
                //                     icon={icon}
                //                     checkedIcon={checkedIcon}
                //                     style={{ marginRight: 8 }}
                //                     checked={(exists.length) ? true : false}
                //                 />
                //                 {option.title}
                //             </li>
                //         )
                //     }}
                //     style={{ width: 280 }}

                //     renderInput={(params) => (
                //         <>
                //             <TextField {...params} label={(props.label)} hiddenLabel size="small" placeholder={"Search " + props.label} />
                //         </>
                //     )}
                // />
                <div className='segment-filter-popup'>

                    <div className='dow-filter-search'>
                        <TextField
                            className='search-box'
                            fullWidth
                            placeholder="Search"
                            onChange={handleSearch}
                            value={searchQuery}
                            InputProps={{
                                startAdornment: (
                                    <div style={{ marginRight: '8px', marginTop: '5px' }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill={searchQuery != '' ? "#333" : "#B2B2B2"}
                                            viewBox="0 0 256 256"
                                        >
                                            <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
                                        </svg>
                                    </div>
                                ),
                                
                                endAdornment: searchQuery != '' && (
                                    <div style={{ marginLeft: '8px', marginTop: '4px', cursor:"pointer" }} onClick={() => setSearchQuery('')} >
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="#B2B2B2" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 0.3125C4.87512 0.3125 3.7755 0.646066 2.8402 1.27102C1.90489 1.89597 1.17591 2.78423 0.745438 3.82349C0.314964 4.86274 0.202333 6.00631 0.421786 7.10958C0.64124 8.21284 1.18292 9.22626 1.97833 10.0217C2.77374 10.8171 3.78716 11.3588 4.89043 11.5782C5.99369 11.7977 7.13726 11.685 8.17651 11.2546C9.21577 10.8241 10.104 10.0951 10.729 9.1598C11.3539 8.2245 11.6875 7.12488 11.6875 6C11.6859 4.49207 11.0862 3.04636 10.0199 1.98009C8.95364 0.913821 7.50793 0.314092 6 0.3125ZM8.05953 7.44047C8.10018 7.48112 8.13243 7.52937 8.15442 7.58248C8.17642 7.63559 8.18775 7.69251 8.18775 7.75C8.18775 7.80748 8.17642 7.86441 8.15442 7.91752C8.13243 7.97063 8.10018 8.01888 8.05953 8.05953C8.01889 8.10018 7.97063 8.13242 7.91752 8.15442C7.86441 8.17642 7.80749 8.18774 7.75 8.18774C7.69252 8.18774 7.63559 8.17642 7.58248 8.15442C7.52938 8.13242 7.48112 8.10018 7.44047 8.05953L6 6.61852L4.55953 8.05953C4.51889 8.10018 4.47063 8.13242 4.41752 8.15442C4.36441 8.17642 4.30749 8.18774 4.25 8.18774C4.19252 8.18774 4.13559 8.17642 4.08248 8.15442C4.02938 8.13242 3.98112 8.10018 3.94047 8.05953C3.89982 8.01888 3.86758 7.97063 3.84558 7.91752C3.82358 7.86441 3.81226 7.80748 3.81226 7.75C3.81226 7.69251 3.82358 7.63559 3.84558 7.58248C3.86758 7.52937 3.89982 7.48112 3.94047 7.44047L5.38149 6L3.94047 4.55953C3.85838 4.47744 3.81226 4.3661 3.81226 4.25C3.81226 4.1339 3.85838 4.02256 3.94047 3.94047C4.02256 3.85838 4.13391 3.81226 4.25 3.81226C4.3661 3.81226 4.47744 3.85838 4.55953 3.94047L6 5.38148L7.44047 3.94047C7.48112 3.89982 7.52938 3.86758 7.58248 3.84558C7.63559 3.82358 7.69252 3.81226 7.75 3.81226C7.80749 3.81226 7.86441 3.82358 7.91752 3.84558C7.97063 3.86758 8.01889 3.89982 8.05953 3.94047C8.10018 3.98112 8.13243 4.02937 8.15442 4.08248C8.17642 4.13559 8.18775 4.19251 8.18775 4.25C8.18775 4.30749 8.17642 4.36441 8.15442 4.41752C8.13243 4.47063 8.10018 4.51888 8.05953 4.55953L6.61852 6L8.05953 7.44047Z" fill="#B2B2B2" />
                                        </svg>
                                    </div>
                                ),
                            }}
                        />
                    </div>

                    {/* <div className='dow-filter-letter'>
                        <span onClick={letterToNumber}>#</span>
                        {
                            isLetter ?
                                allLetters.map((letter) => (
                                    <span
                                        key={letter}
                                        onClick={() => handleLetterFilter(letter)}
                                        className={selectedLetter === letter ? 'selected-letter' : ''}
                                    >
                                        {letter}
                                    </span>
                                ))
                                :
                                allNumbers.map((letter) => (
                                    <span
                                        key={letter}
                                        onClick={() => handleLetterFilter(letter)}
                                        className={selectedLetter === letter ? 'selected-letter' : ''}
                                    >
                                        {letter}
                                    </span>
                                ))
                        }

                    </div> */}
                    <div className='dow-filter-letter'>
                        <span
                            tabIndex={0}
                            onClick={letterToNumber}
                            onKeyDown={(e) => handleLetterKeyPress(e, '#')}
                        >
                            #
                        </span>

                        {isLetter
                            ? allLetters.map((letter) => (
                                <span
                                    key={letter}
                                    tabIndex={0}
                                    onClick={() => handleLetterFilter(letter)}
                                    onKeyDown={(e) => handleLetterKeyPress(e, letter)}
                                    className={selectedLetter === letter ? 'selected-letter' : ''}
                                >
                                    {letter}
                                </span>
                            ))
                            : allNumbers.map((letter) => (
                                <span
                                    key={letter}
                                    tabIndex={0}
                                    onClick={() => handleLetterFilter(letter)}
                                    onKeyDown={(e) => handleLetterKeyPress(e, letter)}
                                    className={selectedLetter === letter ? 'selected-letter' : ''}
                                >
                                    {letter}
                                </span>
                            ))}
                    </div>

                    <div className='dow-filter-items'>
                        {filteredOptions.map((option) => (
                            // <div className='dow-filter-row' key={option.title}>
                            //     <label>
                            //         <Checkbox
                            //             className='dow-filter-checkbox'
                            //             //value={selectedOptions}
                            //             checked={selectedOptions.some((item) => item.title === option.title)}
                            //             onChange={() => handleChangeDow(option)}
                            //             //onChange={handleChange}
                            //             icon={unCheckedIcon}
                            //             checkedIcon={checkedIcon} 
                            //         />
                            //         <span className={`dow-filter-title ${selectedOptions.some((item) => item.title === option.title) ? 'active' : ''}`}>
                            //             {option.title}
                            //         </span>
                            //     </label>
                            // </div>
                            <div className='dow-filter-row' key={option.title}>
                                <label className='dow-filter-item' tabIndex={0} onKeyDown={(e) => handleCheckboxKeyPress(e, option)}>
                                    <Checkbox
                                        className='dow-filter-checkbox'
                                        checked={selectedOptions.some((item) => item.title === option.title)}
                                        onChange={() => handleChangeDow(option)}
                                        icon={unCheckedIcon}
                                        checkedIcon={checkedIcon}
                                        tabIndex={-1}
                                    />
                                    <div className={`dow-filter-title ${selectedOptions.some((item) => item.title === option.title) ? 'active' : ''}`}>
                                        {option.title}
                                    </div>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                :

                <div className='dow-filter-popup'>
                    <div className='dow-filter-items'>
                        {options.map((option) => (
                            <div className='dow-filter-row' key={option.title}>
                                <label>
                                    <Checkbox
                                        className='dow-filter-checkbox'
                                        //value={selectedOptions}
                                        checked={selectedOptions.some((item) => item.title === option.title)}
                                        onChange={() => handleChangeDow(option)}
                                        //onChange={handleChange}
                                        icon={unCheckedIcon}
                                        checkedIcon={checkedIcon} 
                                    />
                                    <span className={`dow-filter-title ${selectedOptions.some((item) => item.title === option.title) ? 'active' : ''}`}>
                                        {getFullDay(option.title)}
                                    </span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

            }



            {/* <Divider /> */}

            <Box className="filter-action-btns">
                <Box>
                    <Button
                        disabled={selectedOptions.length === options.length}
                        className='filter-button secondary'
                        variant="outlined" sx={{ mr: 0.5 }}
                        size="small"
                        onClick={handleSelectAll}
                    >
                        Select All
                    </Button>
                    {props.details.type === "segment" ?
                        <Button
                            disabled={selectedOptions.length < 1}
                            className='filter-button secondary'
                            variant="outlined" sx={{ ml: 1 }}
                            size="small"
                            onClick={handleClearAll}
                        >
                            Clear All
                        </Button>
                        : ""}
                </Box>
                <Box>
                    <Button
                        disabled={selectedOptions.length < 1}
                        className='filter-button primary'
                        variant="outlined"
                        size="small"
                        onClick={handleSubmit}
                    >
                        Apply
                    </Button>
                </Box>
            </Box>
            {/* <Button onClick={handleSubmit} variant="outlined" sx={{ position: "absolute", right: 0, m: .1 }} size="medium">Apply</Button> */}

        </>
    );

}

/** function to get the Array object of top segments  */
export const getTopSegments = () => {
    let topSegmentsList = ["Transient", "Group", "Contract"];
    let topSegments = [];
    topSegmentsList.map((item, index) => {
        let obj = {};
        obj.code = item;
        obj.name = item;
        obj.title = item;
        obj.hidden = false;
        obj.type = "top_segments";
        topSegments.push(obj);
    })
    return topSegments;
}


/** Function to get the Array Object of  room class */
export const getRoomClass = () => {
    let data = (dataService.getSeriesById("GetRoomClass").data) ? deepCopy(dataService.getSeriesById("GetRoomClass").data.data) : [];
    let result = [...getRoomClassCategory(data)];
    let finalArray = [];
    result.map((item, index) => {
        let className = item.replace("roomclass_", "");
        let obj = {};
        obj.code = className;
        obj.name = className;
        obj.title = className;
        obj.hidden = false;
        obj.type = "room_class";
        finalArray.push(obj);
    })
    return finalArray;
}


function getMaxKeysCountWithIndex(objectsArray) {
    let maxKeysCount = 0;
    let maxKeysIndex = -1;

    objectsArray.forEach((obj, index) => {
        const keysCount = Object.keys(obj).length;
        if (keysCount > maxKeysCount) {
            maxKeysCount = keysCount;
            maxKeysIndex = index;
        }
    });

    return { maxKeysCount, maxKeysIndex };
}

const getAllRatePlan =(data) =>{
    let ratePlansArr = [];
    data.forEach((element, index) => {
        let segmentCodesArr = Object.keys(data[index]);
        segmentCodesArr = segmentCodesArr.filter(element => element !== 'index' && element !== 'HotelTotal');
        console.log(index," =>  ",segmentCodesArr);
        segmentCodesArr.map((code)=>{
            if(!ratePlansArr.includes(code)){
                ratePlansArr.push(code);
            }
        })
    });
    return ratePlansArr;
}

/** Function to get the Array Object for RatePlan  */
export const getRatePlan = () => {
    let data = (dataService.getSeriesById("GetRatePlanNoMissingDays").data) ? deepCopy(dataService.getSeriesById("GetRatePlanNoMissingDays").data.data) : [];
    let segmentCodes = [];
    let dataRequest = getMaxKeysCountWithIndex(data);
    let maxKeysIndex = (dataRequest && dataRequest.maxKeysIndex) ? dataRequest.maxKeysIndex : 0
    getAllRatePlan(data);
    if (data && data.length) {
        // segmentCodes = Object.keys(data[maxKeysIndex]);
        // segmentCodes.sort().push(segmentCodes.shift());
        segmentCodes = getAllRatePlan(data);
        segmentCodes.sort();
    }
    let result = [...segmentCodes];
    let finalArray = [];
    result.map((item, index) => {
        let className = item.replace("Segment_", "");
        let obj = {};
        if (!in_array([className], ["HotelTotal", "index"])) {
            obj.name = className;
            obj.code = className;
            obj.title = className;
            obj.hidden = false;
            obj.type = "rate_plan";
            finalArray.push(obj);
        }
    })
    return finalArray;
}


/** Function to get the Array Object for Room Type  */
export const getRoomType = () => {
    let data = (dataService.getSeriesById("GetRoomType").data) ? deepCopy(dataService.getSeriesById("GetRoomType").data.data) : [];
    let segmentCodes = [];
    if (data && data.length) {
        segmentCodes = Object.keys(data[0]);
        segmentCodes.sort().push(segmentCodes.shift());
    }
    let result = [...segmentCodes];
    let finalArray = [];
    result.map((item, index) => {
        let className = item.replace("Segment_", "");
        let obj = {};
        if (!in_array([className], ["HotelTotal", "index"])) {
            obj.name = className;
            obj.code = className;
            obj.title = className;
            obj.hidden = false;
            obj.type = "room_type";
            finalArray.push(obj);
        }
    })

    return finalArray;
}